import { useContent } from '@/lib/content-context'
import { useUX } from '@/ux/context'
import { selectVariant } from '@/ux/selectors'
import { BadgeList } from './BadgeList'
import { DetailedTable } from './DetailedTable'

export function Skills() {
  const { skills } = useContent()
  const ux = useUX()
  const variant = selectVariant('Skills', ux)

  if (variant === 'DetailedTable') {
    return <DetailedTable skills={skills} />
  }

  return <BadgeList skills={skills} />
}
